Vendd.Scripts.load(function () {

    Vendd.MessageBus.subscribe(Vendd.Widget.Messages.BindControl, 'x-product-box', function (envelope) {

        var $context = envelope.message.data.context, model, quickBuyObj, $hoveredProduct,
            $boxes = $('.x-product-box', $context);

        if ($boxes.length < 1)
            return;

        if (!isTouch() && $boxes.data('hasquickbuy')) {
            initProducboxHover($boxes);
        }

        if ($('.takeaway-price-container', $boxes).length > 0) {
            $('.takeaway-price-container', $boxes).each(function () {
                initTakeAwayPrice($(this));
            });
        }

        $boxes.on('click', '.js-remove-from-cart', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var $this = $(this), $box, cartIds;

            $box = $this.closest('.x-product-box');

            cartIds = $box.prop('data-cartproductid');

            Vendd.MessageBus.publishAsync($box.get(0), new Vendd.Cart.Messages.MultipleRemove(cartIds));

            Vendd.MessageBus.subscribe(Vendd.Cart.Messages.MultipleRemoveSuccess, $box, function (envelope) {
                $this.attr('disabled', 'disabled').parent().addClass('disabled');
                toastr.success(envelope.message.data.data.SuccessMessage, "", { timeOut: 1200, showDuration: 1000, hideDuration: 700 });
                Vendd.MessageBus.unsubscribe(Vendd.Cart.Messages.MultipleRemoveSuccess, $box);
            });
        });

        $boxes.on('click', '.js-add-to-cart', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var $this = $(this),
                $box, $qty,
                id, skuId, path, qty, extraAttributes, bundleItems, color, colorId, size, $wrapper, list, recipeItems, comboItems;

            if ($this.hasClass('x-disabled') || $this.is(':disabled'))
                return;
            if ($('.x-warehouse-selector-widget').trigger('addtocart').hasClass('opening'))
                return;

            $box = $this.closest('.x-product-box');
            $qty = $('.js-qty', $box);

            id = $box.data('productid');
            skuId = $box.data('variantid');
            var defaultcolorId = $box.data('default-colorid');

            path = $box.data('path');
            qty = ($qty.val() ? stringToNumber($qty.val()) : null) || 1;
            extraAttributes = [];
            bundleItems = [];
            recipeItems = [];
            comboItems = [];

            var itemInfo = {
                minQuantity: parseInt($box.data('min-quantity') || 0),
                maxQuantity: parseInt($box.data('max-quantity') || 0),
                quanta: parseInt($box.data('quanta') || 0)
            };

            //enhanced info
            color = $box.attr('data-color');
            size = $box.attr('data-size');
            colorId = $box[0].SelectedColorId || defaultcolorId || 0;

            $wrapper = $this.closest('.x-control.x-product-list');
            list = $wrapper.data('list');

            var enhancedInfo = { color: color, size: size, list: list, colorId: colorId };
            //enhanced info

            Vendd.MessageBus.publishAsync($box.get(0), new Vendd.Cart.Messages.Add(id, skuId, path, qty, extraAttributes, bundleItems, recipeItems, comboItems, itemInfo, enhancedInfo));
            //Open the widget only for template 1 of Cart Widget
            if ($('.x-cart-widget').data('template') === 1) {
                if ($box.closest('.x-searchbox.elastic').length > 0) {
                    toastr.success(LhApp.Function.getText("Common:ProductAddedToCart"), "", { timeOut: 1200, showDuration: 300, hideDuration: 700 });
                } else {
                    Vendd.MessageBus.publishAsync($wrapper, new Vendd.Widget.Messages.OpenWidget(Vendd.Widget.CartWidget, false));
                }
            }

        });

        $boxes.on('click', '.js-remove-from-wishlist', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var $this = $(this), $box, wishlistItemId;

            if ($this.closest('.wishlist-button').hasClass('x-disabled'))
                return;

            $box = $this.closest('.x-product-box');

            if ($boxes.data('hasquickbuy')) {
                var varId = parseInt($box.data('variantid'));
                var wishlistModel = JSON.parse(localStorage.getItem("CurrentWishlistModel"));
                var selectedsku = _.find(wishlistModel.Items, function (item) { return varId === item.VariantId });
                wishlistItemId = selectedsku.Id;
            } else {
                wishlistItemId = $box.prop('data-wishlistitemid');
            }

            Vendd.MessageBus.publishAsync($box.get(0), new Vendd.Wishlist.Messages.Remove(wishlistItemId));
        });

        $boxes.on('click', '.js-add-to-wishlist', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var $this = $(this),
                $box, $qty,
                id, skuId, path, qty, extraAttributes, bundleItems;

            if ($this.closest('.wishlist-button').hasClass('x-disabled'))
                return;

            $box = $this.closest('.x-product-box');
            $qty = $('.js-quantity', $box);

            id = $box.data('productid');
            skuId = $box.data('variantid');
            path = $box.data('path');
            qty = ($qty.val() ? stringToNumber($qty.val()) : null) || 1;
            extraAttributes = [];
            bundleItems = [];


            if (LhApp.Context.MultipleWishlistsEnabled && $('.js-wishlist-lists', $box).length > 0) {
                LhApp.Function.hideAllProductWishlists();
                var product = { id: id, skuId: skuId, path: path, qty: qty };
                LhApp.Function.showProductWishlists($box, product);
            } else {
                Vendd.MessageBus.publishAsync($box.get(0), new Vendd.Wishlist.Messages.Add(id, skuId, path, qty, extraAttributes, bundleItems));
            }
        });

        $boxes.on('click', '.js-remove-from-compare', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var $this = $(this), $box, productId;

            if ($this.closest('.compare-button').hasClass('x-disabled'))
                return;

            $box = $this.closest('.x-product-box');

            productId = $box.prop('data-productid');

            Vendd.MessageBus.publishAsync($box.get(0), new Vendd.ProductCompare.Messages.Remove(productId));

            if ($('.x-productcompare-widget').data('template') === 1) {
                Vendd.MessageBus.publishAsync($box.get(0), new Vendd.Widget.Messages.OpenWidget(Vendd.Widget.ProductCompareWidget, false));
            }
        });

        $boxes.on('click', '.js-add-to-compare', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var $this = $(this),
                $box, $qty,
                id, skuId, path, qty;

            if ($this.closest('.compare-button').hasClass('x-disabled'))
                return;

            $box = $this.closest('.x-product-box');
            $qty = $('.js-quantity', $box);

            id = $box.data('productid');
            skuId = $box.data('variantid');
            path = $box.data('path');
            qty = ($qty.val() ? stringToNumber($qty.val()) : null) || 1;

            Vendd.MessageBus.publishAsync($box.get(0), new Vendd.ProductCompare.Messages.Add(id, skuId));

            if ($('.x-productcompare-widget').data('template') === 1) {
                Vendd.MessageBus.publishAsync($box.get(0), new Vendd.Widget.Messages.OpenWidget(Vendd.Widget.ProductCompareWidget, false));
            }
        });

        $boxes.on('click', '.js-qty-change', function (e) {
            var $this, $spinner, $input, val, min, max, step;

            $this = $(this);
            $spinner = $this.parent();
            $input = $this.siblings('input[name="qty"]').eq(0);
            val = parseFloat($input.val()).toFixed(2);
            min = $(this).closest("article").attr("data-min-quantity");
            max = $(this).closest("article").attr("data-max-quantity");
            step = $(this).closest("article").attr("data-quanta");

            if ($spinner.hasClass('x-disabled'))
                return;

            if ($this.hasClass('js-decrement')) {

                if (min === "" && max === "" && step === "") {
                    min = parseInt($spinner.data('min'));
                    max = parseInt($spinner.data('max'));
                    step = parseInt($spinner.data('step'));

                    if ((parseInt(val) - parseInt(step)) <= parseInt(min)) {
                        val = parseInt(min);
                    } else {
                        val = parseInt(val) - parseInt(step);
                    }
                }
                else if (Vendd.Helpers.isInteger(parseFloat(step))) {
                    val = parseInt(val) - parseInt(step);
                }
                else if (parseFloat(val) > parseFloat(min) && (parseFloat(val) - parseFloat(step) >= parseFloat(min))) {
                    val = parseFloat(val) - parseFloat(step);
                    val = parseFloat(val).toFixed(2);
                }

                $input.val(val);
                $this.siblings('.js-increment').removeClass('disabled');
                $this.siblings('.js-increment').removeAttr('disabled');

                if (val === min) {
                    $this.addClass('disabled');
                    $this.attr('disabled', 'disabled');
                }
            } else if ($this.hasClass('js-increment')) {

                if (min === "" && max === "" && step === "") {
                    min = parseInt($spinner.data('min'));
                    max = parseInt($spinner.data('max'));
                    step = parseInt($spinner.data('step'));
                    val = parseInt(val) + parseInt(step);
                }
                else if (Vendd.Helpers.isInteger(parseFloat(step))) {
                    val = parseInt(val) + parseInt(step);
                }
                else if (parseFloat(val) < parseFloat((max == null || max === "" || max <= 0 ? 1000000 : max)) && (parseFloat(val) + parseFloat(step)) <= parseFloat((max == null || max === "" || max <= 0 ? 1000000 : max))) {
                    val = parseFloat(val) + parseFloat(step);
                    val = parseFloat(val).toFixed(2);
                }

                $input.val(val);
                $this.siblings('.js-decrement').removeClass('disabled');
                $this.siblings('.js-decrement').removeAttr('disabled');

                if (val === max) {
                    $this.addClass('disabled');
                    $this.attr('disabled', 'disabled');
                }
            }
        });

        $boxes.on('keydown', '.js-qty', function (e) {
            numbersOnly(e);
        });

        $boxes.on('click', '.js-select-product', function (e) {

            var $this, $box, id, $wrapper, list;
            $this = $(this);

            $box = $this.closest('.x-product-box');

            id = $box.data('productid');

            $wrapper = $this.closest('section.x-product-list');
            list = $wrapper.data('list');

            Vendd.MessageBus.publish($box.get(0), new Vendd.Product.Messages.ProductSelected(id, list));
        });

        if (!isTouch()) {
            $boxes.on('click', '.js-color-pick', function (e) {
                var $this = $(this), $box;
                var colorIndex = $this.parent().index();

                $box = $this.closest('.x-product-box');

                if (!$this.parent().hasClass('selected')) {
                    $this.parent().addClass('selected').siblings('.selected').removeClass('selected');

                    $('.image-container .color-dimension', $box).eq(colorIndex).addClass('shown').removeClass('hidden').siblings('.shown').addClass('hidden').removeClass('shown');
                }
            });
            $boxes.on('mouseenter', '.js-color-pick', function (e) {
                var $this = $(this), $box;
                var colorIndex = $this.parent().index();

                $box = $this.closest('.x-product-box');

                if (!$this.parent().hasClass('selected')) {
                    $this.parent().addClass('selected').siblings('.selected').removeClass('selected');

                    $('.image-container .color-dimension', $box).eq(colorIndex).addClass('shown').removeClass('hidden').siblings('.shown').addClass('hidden').removeClass('shown');
                }
            });
        }

        $boxes.on('click', '.js-quick-view', function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (isTouch()) {
                window.location.href = $('> a', $(this).closest('.image-container')).attr('href');
                return;
            }
            var $this = $(this),
                $box, $qty,
                id, skuId, path, qty, extraAttributes, bundleItems;

            $box = $this.closest('.x-product-box');
            $qty = $('.js-quantity', $box);

            id = $box.data('productid');
            skuId = $box.data('variantid');
            path = $box.data('path');
            qty = ($qty.val() ? stringToNumber($qty.val()) : null) || 1;
            extraAttributes = [];
            bundleItems = [];

            var Href = '/pages/productdetailspopup.aspx?iid=' + id + '&path=' + path + '&Quantity=' + qty;
            $.fancybox.open({
                src: Href,
                type: 'iframe',
                maxWidth: 840,
                //maxHeight: 745,
                fitToView: false,
                //width: '100%',
                //height: '100%',
                autoSize: false,
                closeClick: false,
                openEffect: 'none',
                closeEffect: 'none',
                padding: 0,
                beforeShow: function () {
                    var fancy = $('.fancybox-iframe');
                    fancy.closest('.fancybox-skin').addClass('quick-view');
                    fancy.contents().find('html').addClass('quick-view');
                    fancy.contents().find('.fancybox-my-close').on('click', function () { $.fancybox.close(); });
                    this.width = ($('.fancybox-iframe').contents().find('.product-details-popup').width());
                    this.height = ($('.fancybox-iframe').contents().find('html').height());
                },
                afterClose: function () {
                }
            });
        });

        $boxes.on('click', '.js-set-delivery-point', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var $this = $(this), $box, deliveryPointId;

            $box = $this.closest('.x-product-box');

            deliveryPointId = $this.data('id');

            $('.js-set-delivery-point').addClass('x-disabled').attr('disabled', 'disabled').parent().addClass('x-loading');

            Vendd.MessageBus.publishAsync($box.get(0), new Vendd.Cart.Messages.SetDeliveryPoint(deliveryPointId));
        });

        $boxes.on('click', '.js-quick-buy', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var $this = $(this);
            var $box = $this.closest($boxes);

            if (!$box.data('hasquickbuy'))
                return;

            $boxes.removeClass('shown');
            $box.addClass('shown');

            if (!$box.hasClass('x-initialized')) {
                initQuickBuy($box);
            }
        });

        function initQuickBuy($wrapper) {

            var wrapper = $wrapper.get(0);
            wrapper.productId = $wrapper.data('productid');
            wrapper.defaultColor = $wrapper.data('default-colorid');
            wrapper.selectedColor = $wrapper.data('selected-colorid');

            var state = Vendd.Quickbuy.initState(wrapper.productId, wrapper.defaultColor);

            if (state == undefined) return;

            wrapper.model = state;
            wrapper.dimensionWidget = $('.x-dimensions-widget', $wrapper);
            wrapper.cartButton = $('.add-to-cart', $wrapper);
            wrapper.wishlistButton = $('.wishlist-button', $wrapper);
            wrapper.compareButton = $('.compare-button', $wrapper);
            wrapper.priceElement = $('.current-price', $wrapper);
            wrapper.deletedPriceElement = $('.deleted-price', $wrapper);
            wrapper.discountPercentageElement = $('.discount-percentage', $wrapper);
            wrapper.discountValueElement = $('.discount-value', $wrapper);
            wrapper.image = $('.image-container', $wrapper).find('img');

            if (!state.HasColors && !state.HasSizes && !state.HasDim3) {
                wrapper.cartButton.removeClass('x-disabled').find('button').prop("disabled", false);
                wrapper.wishlistButton.removeClass('x-disabled');
                wrapper.compareButton.removeClass('x-disabled');
                return;
            }

            if (state.HasSingleDim) $wrapper.addClass('has-one-dim');
            if (state.HasTwoDims) $wrapper.addClass('has-two-dims');
            if (state.HasThreeDims) $wrapper.addClass('has-three-dims');

            //check color selector for new state
            if ($wrapper.data('hascolorselector') && $('.js-color-selector.selected', $wrapper).length > 0) {
                state.createNewColorState = true;
                if (wrapper.defaultColor === wrapper.selectedColor) {
                    state.defaultDimId = wrapper.defaultColor;
                } else {
                    state.defaultDimId = wrapper.selectedColor;
                }
            }

            //create new state
            if (state.createNewColorState) {
                Vendd.Quickbuy.createNewState(wrapper, state.defaultDimId, wrapper.productId, wrapper.defaultColor, 'color');
            } else if (state.createNewSizeState) {
                Vendd.Quickbuy.createNewState(wrapper, state.defaultDimId, wrapper.productId, wrapper.defaultColor, 'size');
            } else if (state.createNewDim3State) {
                Vendd.Quickbuy.createNewState(wrapper, state.defaultDimId, wrapper.productId, wrapper.defaultColor, 'dim3');
            }

            wrapper.UpdateBoxData = function (type, imgSrc) {
                var $wrapper = $(this);

                if (type === 'color' && typeof imgSrc != 'undefined')
                    wrapper.image.attr('src', imgSrc);

                var selectedColorId = (typeof wrapper.SelectedColorId != 'undefined') ? wrapper.SelectedColorId : null;
                var selectedSizeId = (typeof wrapper.SelectedSizeId != 'undefined') ? wrapper.SelectedSizeId : null;
                var selectedDim3Id = (typeof wrapper.SelectedDim3Id != 'undefined') ? wrapper.SelectedDim3Id : null;

                if ((wrapper.model.HasColors && !state.HasSingleColor && selectedColorId == null)
                    || (wrapper.model.HasSizes && !state.HasSingleSize && selectedSizeId == null)
                    || (wrapper.model.HasDim3 && !state.HasSingleDim3 && selectedDim3Id == null)) {
                    wrapper.cartButton.addClass('x-disabled').find('button').prop("disabled", true);
                    wrapper.wishlistButton.addClass('x-disabled');
                    wrapper.compareButton.addClass('x-disabled');
                    return;
                }

                var selectedSku = Vendd.Quickbuy.GetSkuData(wrapper, wrapper.productId, wrapper.defaultColor, selectedColorId, selectedSizeId, selectedDim3Id);

                if (selectedSku !== null && typeof selectedSku !== "undefined") {
                    var skuData = selectedSku.SkuData;

                    $wrapper.data('variantid', skuData.SkuId);

                    if (!(skuData.CanBuy || skuData.CanPreorder)) {
                        wrapper.cartButton.addClass('x-disabled').find('button').prop("disabled", true).prev('.availability').html(skuData.NoAvailabilityName);
                    } else {
                        wrapper.cartButton.removeClass('x-disabled').find('button').prop("disabled", false).prev('.availability').html(skuData.NoAvailabilityName);
                    }

                    var wishlistModel = JSON.parse(localStorage.getItem("CurrentWishlistModel"));

                    if (wishlistModel) {
                        var selectedsku = _.find(wishlistModel.Items, function (item) { return skuData.SkuId === item.VariantId });
                        var $wishlistButton = $('.wishlist-button', $wrapper);
                        if (selectedsku) {
                            $wishlistButton.addClass('already-in-wishlist');
                            $('.js-add-to-wishlist', $wishlistButton).addClass('disabled');
                            $('.js-remove-from-wishlist', $wishlistButton).removeClass('disabled');
                        } else {
                            $wishlistButton.removeClass('already-in-wishlist');
                            $('.js-add-to-wishlist', $wishlistButton).removeClass('disabled');
                            $('.js-remove-from-wishlist', $wishlistButton).addClass('disabled');
                        }
                    }

                    wrapper.wishlistButton.removeClass('x-disabled');
                    wrapper.compareButton.removeClass('x-disabled');

                    //manipulate prices - global variable from formatPrices.js
                    if ($enableFormatPrices) {
                        if (!wrapper.priceElement.hasClass('price-formatted')) {
                            wrapper.priceElement.addClass('price-formatted');
                        }
                        wrapper.priceElement.html(formatPrice(skuData.UnitPrice));
                    } else {
                        wrapper.priceElement.text(skuData.UnitPrice);
                    }
                    wrapper.deletedPriceElement.text(skuData.DeletedPrice);
                    wrapper.discountPercentageElement.text(skuData.DiscountPercentage);
                    wrapper.discountValueElement.text(skuData.DiscountValue);
                }
            };

            $wrapper.on('click', '.js-dimensions li', function (e) {

                var $this = $(this), id, type, name, $wrap, wrapper, productId, defaultColor, imgSrc,
                    isColorList, isSizeList, isDim3List, $color, $size;

                if ($this.hasClass('selected') || $this.hasClass('disabled'))
                    return;

                id = $this.data('id');
                name = $this.data('name');
                type = $this.closest('.dropdown-content').data('type');

                isColorList = ($this.parent().hasClass('colors-list')) ? true : false;
                isSizeList = ($this.parent().hasClass('sizes-list')) ? true : false;
                isDim3List = ($this.parent().hasClass('dim3-list')) ? true : false;

                if (isColorList) imgSrc = $this.find('img').attr('src');

                $wrap = $this.closest('.x-product-box');
                wrapper = $wrap.get(0);
                productId = $wrap.data('productid');
                defaultColor = $wrap.data('default-colorid');

                $this.addClass('selected').siblings().removeClass('selected');
                $this.closest('.dropdown-list').find('.selected-text').html(name);

                if (id === undefined) return;

                var state = Vendd.Quickbuy.createNewState(wrapper, id, productId, defaultColor, type);
                Vendd.Quickbuy.Update(wrapper.dimensionWidget, state);

                if (isColorList) {
                    wrapper.UpdateBoxData("color", imgSrc);
                    $wrap.attr('data-color', name);
                } else if (isSizeList) {
                    wrapper.UpdateBoxData("size", imgSrc);
                    $wrap.attr('data-size', name);
                } else if (isDim3List) {
                    wrapper.UpdateBoxData("dim3", imgSrc);
                    $wrap.attr('data-dim3', name);
                }

            });

            $wrapper.on('click', '.js-dropdown-btn', function (e) {
                var $this = $(this);

                if ($this.hasClass('disabled')) return;

                if ($this.hasClass('expanded')) {
                    $this.removeClass('expanded');
                } else {
                    $('.js-dropdown-btn.expanded').removeClass('expanded');
                    $this.addClass('expanded');
                }
            });

            $(document).click(function (event) {
                if (!$(event.target).closest('.js-dropdown-btn').length &&
                    !$(event.target).is('.js-dropdown-btn')) {

                    $('.js-dropdown-btn').removeClass("expanded");
                }
            });

            $wrapper.closest('.x-product-list').on('mouseleave', function (e) {
                $('.x-product-box.hovered').removeClass('hovered');
                $('.js-dropdown-btn.expanded').removeClass('expanded');
            });

            Vendd.Quickbuy.Update(wrapper.dimensionWidget, state);

            wrapper.UpdateBoxData();

            $wrapper.addClass('x-initialized');
        }

        function initProducboxHover($productBox) {
            if ($productBox.length == 0)
                return;

            var config = {
                sensitivity: 50,
                interval: 180,
                over: mouseenter,
                timeout: 10,
                out: mouseleave
            };

            function mouseenter() {
                $this = $(this);
                if (!isTouch()) {
                    $this.addClass('hovered').parent().siblings().children().removeClass('hovered');
                }
            }

            function mouseleave() {
                return;
            }

            $productBox.hoverIntent(config);
        }

        function initTakeAwayPrice($productBox) {
            if ($productBox.length == 0)
                return;

            var takeawayprice = $('.takeaway-price', $productBox).text();
            if (takeawayprice != "") {
                $('.takeaway-price', $productBox).text(LhApp.Function.renderPrice(parseFloat(takeawayprice)));
            }
        }
    });

    Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Changed, 'x-product-box', function (envelope) {
        var data = envelope.message.data.Cart.Items;

        var $boxes = $('.x-product-box');

        if ($boxes.length < 1)
            return;

        $boxes.each(function (i, el) {
            var $el = $(el);
            var id = $el.data('productid');
            var quantityInCart = 0, idsInCart = [], inCart = false;

            $el.find('.js-remove-from-cart').attr('disabled', 'disabled').parent().addClass('disabled');

            for (var j = 0; j < data.length; j++) {
                if (id == data[j].ProductId) {
                    quantityInCart += data[j].Quantity;
                    idsInCart.push(data[j].Id);
                    inCart = true;
                }
            }
            if (inCart) {
                $el.prop('data-cartproductid', idsInCart);
                $el.find('.js-remove-from-cart').removeAttr('disabled').parent().removeClass('disabled');
                $el.find('.js-cart-quantity').text("(" + quantityInCart + ")");
            }
        });
    });

    Vendd.MessageBus.subscribe(Vendd.Wishlist.Messages.Changed, 'x-product-box', function (envelope) {
        var data = envelope.message.data.Items;
        var $boxes = $('.x-product-box');

        if ($boxes.length < 1)
            return;

        $boxes.each(function (i, el) {
            var $el = $(el);
            var id = $el.data('variantid');

            if (data) {
                var productInWishlist = _.find(data, function (x) { return id === x.VariantId });
                var $wishlistButton = $('.wishlist-button', $el);

                if (productInWishlist) {
                    $el.prop('data-wishlistitemid', productInWishlist.Id);
                    $wishlistButton.addClass('already-in-wishlist');
                    $('.js-add-to-wishlist', $wishlistButton).addClass('disabled');
                    $('.js-remove-from-wishlist', $wishlistButton).removeClass('disabled');
                } else {
                    $wishlistButton.removeClass('already-in-wishlist');
                    $('.js-add-to-wishlist', $wishlistButton).removeClass('disabled');
                    $('.js-remove-from-wishlist', $wishlistButton).addClass('disabled');
                }
            }

        });

    });

    Vendd.MessageBus.subscribe(Vendd.ProductCompare.Messages.GetWidgetModelSuccess, 'x-product-box', function (envelope) {
        var data = envelope.message.data.model.Items;
        var $boxes = $('.x-product-box');

        if ($boxes.length < 1)
            return;

        $boxes.each(function (i, el) {
            var $el = $(el);
            var id = $el.data('productid');

            if (data) {
                var productInCompare = _.find(data, function (x) { return id === x.Id });
                var $compareButton = $('.compare-button', $el);

                if (productInCompare) {
                    $el.prop('data-productid', productInCompare.Id);
                    $compareButton.addClass('already-in-compare');
                    $('.js-add-to-compare', $compareButton).addClass('disabled');
                    $('.js-remove-from-compare', $compareButton).removeClass('disabled');
                } else {
                    $compareButton.removeClass('already-in-compare');
                    $('.js-add-to-compare', $compareButton).removeClass('disabled');
                    $('.js-remove-from-compare', $compareButton).addClass('disabled');
                }
            }

        });

    });

    Vendd.MessageBus.subscribe(Vendd.UserWishlist.Messages.GetModelSuccess, 'x-product-box', LhApp.Function.hideAllProductWishlists);

});
